import ReactDragListView from './ReactDragListView';
import ReactDragColumnView from './ReactDragColumnView';

ReactDragListView.DragColumn = ReactDragColumnView;
export default ReactDragListView;

// build node version: 11.15.0